document.addEventListener('DOMContentLoaded', () => {
  (() => {
    // 滚动条锁定功能
    function lockBodyScroll() {
      // 计算滚动条宽度
      const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;

      // 设置CSS变量
      document.documentElement.style.setProperty('--scrollbar-width', scrollbarWidth + 'px');

      // 锁定滚动
      document.body.classList.add('lymow__body-locked');
      console.log('锁定页面滚动，滚动条宽度:', scrollbarWidth);
    }

    function unlockBodyScroll() {
      // 恢复滚动
      document.body.classList.remove('lymow__body-locked');

      // 清除CSS变量
      document.documentElement.style.removeProperty('--scrollbar-width');
      console.log('恢复页面滚动');
    }


    function openModal(selectorString, youtubeId) {
      const modal = document.querySelector(selectorString);
      if (modal && youtubeId) {
        const iframe = modal.querySelector('.lymow-youtube-play__modal-iframe');
        iframe.src = `https://www.youtube.com/embed/${youtubeId}`;
        modal.style.display = 'flex';
        lockBodyScroll();
      }
    }

    // 关闭模态框的通用函数
    function closeModal(modal) {
      const iframe = modal.querySelector('.lymow-youtube-play__modal-iframe');
      iframe.src = '';
      modal.style.display = 'none';
      unlockBodyScroll();
    }

    // 为所有关闭按钮绑定事件监听器
    const closeButtons = document.querySelectorAll('.lymow-youtube-play__modal-close');
    closeButtons.forEach(closeButton => {
      closeButton.addEventListener('click', () => {
        const modal = closeButton.closest('.lymow-youtube-play__modal');
        closeModal(modal);
      });
    });

    // 为所有模态框绑定点击外部关闭事件
    const modals = document.querySelectorAll('.lymow-youtube-play__modal');
    modals.forEach(modal => {
      modal.addEventListener('click', (e) => {
        // 只有当点击的是模态框背景时才关闭（不是内容区域）
        if (e.target === modal) {
          closeModal(modal);
        }
      });
    });

    // 添加ESC键关闭模态框功能
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        // 查找当前打开的模态框
        const openModal = document.querySelector('.lymow-youtube-play__modal[style*="flex"]');
        if (openModal) {
          closeModal(openModal);
        }
      }
    });

    window.lockBodyScroll = lockBodyScroll;
    window.unlockBodyScroll = unlockBodyScroll;
    window.openModal = openModal;
  })();
});